import {
  addDays,
  parse,
  isBefore,
  isWithinRange,
  endOfDay,
  startOfDay,
} from 'date-fns'
import axios from 'axios'
import stringUtils from '@/string-utils'
import authenticate from './authenticate'
import localStorageManager from '../localStorageManager'

export const groupTypes = {
  stationCategory: {
    value: 'station_category',
  },
  mediaType: {
    value: 'data_media_type',
  },
  dateTime: {
    value: 'dateTime',
  },
}

export const discreteSampleType = 'discrete'

function initialState() {
  return {
    timeSeriesStations: [],
    grabSampleStations: [],
    allStationsDistinct: [],
    stationDetails: [],
    waterqualityStationDetail: [],
    // stationDocuments is: array of {name: options.name, items: { StationName: options.name, Documents: docList }}
    stationDocuments: [],

    // stationNotes is: array of {name: options.name, items: { StationName: options.name, Notes: notesList }}
    stationNotes: [],
    wqData: [],

    // Start date and end date start the same as the max/min dates. However, while start/end change with the selection and are the ones sent to queries, the max/minBounds always stay the same until the next query
    startDate: new Date('2000-01-02'),
    endDate: new Date(),
    minDateBound: new Date('2000-01-02'),
    maxDateBound: new Date(),
    currentStation: '',
    stationLoading: false,
    mediaTypeList: undefined,
    stationCategories: undefined,
    stationCategoriesContinuous: [],
    tagList: undefined,
    CalendarMark: { DateTimeGroups: [] },
    selectTimeSeries: '',
    CorrectionLogs: [],
    Loaded: false,
    showLogsError: false,
  }
}
export const reportTypes = {
  wqMonthly: {
    configKey: 'WQ_Monthly_Report',
    display: 'WQ Monthly Report',
  },
  bcMoeMonthly: {
    configKey: 'BC_MOE_Monthly_Report',
    display: 'BC MOE Monthly Report',
  },
  riss: {
    configKey: 'RISS_Monthly_Report',
    display: 'RISS Monthly Report',
  },
  allExport: {
    configKey: 'Export_All_Data',
    display: 'Export All Data',
  },
  bcMOE: {
    configKey: 'BC_MOE_Report',
    display: 'BC MOE Report (implemented for Silvertip and B2Gold)',
  },
  tenantGraphDashboard: {
    configKey: 'Tenant_Graphing_Dashboard',
    display: 'Tenant Graphing Dashbaord(implemented only for Fortis now)',
  },
}
export default {
  namespaced: true,
  state: initialState,
  mutations: {
    timeSeriesStations(state, data) {
      state.timeSeriesStations = data || []
    },
    refreshDistinctStationsUnion(state) {
      // Update the combined list of all stations.
      let stationsUnion = []
      state.grabSampleStations.forEach(stn => {
        if (!stn.sampleTypes) {
          stn.sampleTypes = []
        }
        if (stn.sampleType && !stn.sampleTypes.includes(stn.sampleType)) {
          stn.sampleTypes.push(stn.sampleType)
        }
        if (!stn.descriptions) {
          stn.descriptions = []
        }
        if (stn.description && !stn.descriptions.includes(stn.description)) {
          stn.descriptions.push(stn.description)
        }

        stationsUnion.push(stn)
      })
      let foundStation = null
      state.timeSeriesStations.forEach(stn => {
        foundStation = stationsUnion.find(check => check.name === stn.name)
        if (!foundStation) {
          if (!stn.sampleTypes) {
            stn.sampleTypes = []
          }
          if (stn.sampleType && !stn.sampleTypes.includes(stn.sampleType)) {
            stn.sampleTypes.push(stn.sampleType)
          }
          if (!stn.descriptions) {
            stn.descriptions = []
          }
          if (stn.description && !stn.descriptions.includes(stn.description)) {
            stn.descriptions.push(stn.description)
          }

          stationsUnion.push(stn)
        } else {
          if (stn.sampleType && !foundStation.sampleTypes.includes(stn.sampleType)) {
            foundStation.sampleTypes.push(stn.sampleType)
          }
          foundStation.medias = foundStation.medias.concat((stn.medias &&
            stn.medias.filter(addMedia => !foundStation.medias.includes(addMedia)) || []))
          if (stn.description && !foundStation.descriptions.includes(stn.description)) {
            foundStation.descriptions.push(stn.description)
          }
        }
      })
      state.allStationsDistinct = stationsUnion
    },
    rSynonym(state, data) {
      let i = state.grabSampleStations.indexOf(data.station)
      let i2 = state.grabSampleStations[i].synonyms.indexOf(data.synonym)
      state.grabSampleStations[i].synonyms.splice(i2, 1)
    },
    rStation(state, data) {
      let dc = JSON.parse(JSON.stringify(state.grabSampleStations))
      let station = dc.find(x => x.name == data.name)
      let i = dc.indexOf(station)
      dc.splice(i, 1)
      state.grabSampleStations = dc
    },
    addNewStationToList(state, data) {
      let dc = JSON.parse(JSON.stringify(state.grabSampleStations))
      let mappedData = {
        id: data.Id,
        name: data.LocationIdentifier,
        sampleType: 'discrete',
        locationType: data.LocationType,
        description: data.LocationDescription,
        medias: [],
        synonyms: data.Synonyms,
        position: {
          lat: data.Latitude,
          lng: data.Longitude,
        },
      }
      dc.push(mappedData)
      state.grabSampleStations = dc
    },
    grabSampleStations(state, data) {
      state.grabSampleStations = data || []
    },
    stationDetails(state, data) {
      let repeat = state.stationDetails.findIndex(x => x.name == data.name)
      if (repeat != -1) {
        state.stationDetails.splice(repeat, 1)
      }
      state.stationDetails.push(data)
    },
    waterqualityStationDetail(state, data) {
      var dc = []
      dc.push(data)
      state.waterqualityStationDetail = dc
    },
    stationDocuments(state, {
      name: name,
      items: {
        StationName: StationName,
        Documents: StationDocuments,
      },
    }) {
      // e.g.
      // {name: 'WQ19A',
      // items: { StationName: 'WQ19A',
      // Documents: [{
      // FileName: 'MD8 Evapotranspiration Calculations_20170525.pdf',
      // Thumbnail: '/Documents/Thumbnail/58be69a2-2b3b-4e17-9e50-f794a6dbf215',
      // FileUrl: '/Documents/58be69a2-2b3b-4e17-9e50-f794a6dbf215',
      // Description: 'Station Information Sheet from Sharepoint.pdf',
      // UploadedAt: date-fns.parse('2017-08-23T21:56:45Z'),
      // }]}}
      var isFound = false
      if (name) {
        if (state.stationDocuments && 0 !== state.stationDocuments.length) {
          var matchedStation = state.stationDocuments.find(stn => stn.name === name)
          if (matchedStation) {
            matchedStation.items.Documents = (StationDocuments || [])
            isFound = true
          }
        }

        if (!isFound) {
          state.stationDocuments.push({
            'name': name,
            items: {
              'StationName': StationName,
              'Documents': StationDocuments,
            },
          })
        }
      }
    },
    stationNotes(state, data) {
      state.stationNotes.push(data)
    },
    startDate(state, data) {
      state.startDate = data ? startOfDay(data) : null
    },
    endDate(state, data) {
      state.endDate = data ? endOfDay(data) : null
    },
    minDateBound(state, data) {
      state.minDateBound = startOfDay(data)
    },
    maxDateBound(state, data) {
      state.maxDateBound = endOfDay(data)
    },
    wqData(state, data) {
      state.wqData = data
    },
    currentStation(state, data) {
      state.currentStation = data
    },
    SET_USER_RECENT_STATIONS_NAVIGATED(state, data) {
      state.recentStationIdsNavigated = data.faves || []
    },
    EditStationName(state, data) {
      var dc = JSON.parse(JSON.stringify(state.grabSampleStations))
      let editStation = dc.find(x => x.id == data.StationId)
      let currentStation = editStation.synonyms.find(x => x.Name == state.currentStation)
      currentStation.IsPrimary = false
      if (data.DepthHeightDatumId > 0) {
        currentStation.IsDepthHeightDatum = true
        currentStation.DepthHeightStartValue = data.DepthHeightStartValue
        currentStation.DepthHeightEndValue = data.DepthHeightEndValue
        currentStation.DepthHeightDatumId = data.DepthHeightDatumId
        if (data.Datum !== null) {
          currentStation.Datum = data.Datum
        }
      }
      if (data.StationAliaId != null) {
        editStation.synonyms.find(x => x.Name == data.StationName).IsPrimary = true
      } else {
        let deleteStationId = dc.findIndex(x => x.name == data.StationName)
        dc.splice(deleteStationId, 1)
      }
      editStation.name = data.StationName
      let i = dc.findIndex(x => x.id == data.StationId)
      dc.splice(i, 1, editStation)
      state.grabSampleStations = dc
    },
    AddStationName(state, data) {
      var addSynonyms = {
        Id: data.StationAliaId,
        IsPrimary: true,
        IsQaQc: false,
        IsDepthHeightDatum: false,
        Name: data.StationName,
        QaQcType: 'Duplicate',
      }
      var dc = JSON.parse(JSON.stringify(state.grabSampleStations))
      let editStation = dc.find(x => x.id == data.StationId)
      let i = dc.indexOf(editStation)
      let currentStation = editStation.synonyms.find(x => x.Name == state.currentStation)
      currentStation.IsPrimary = false
      if (data.DepthHeightDatumId > 0) {
        currentStation.IsDepthHeightDatum = true
        currentStation.DepthHeightStartValue = data.DepthHeightStartValue
        currentStation.DepthHeightEndValue = data.DepthHeightEndValue
        currentStation.DepthHeightDatumId = data.DepthHeightDatumId
        if (data.Datum !== null) {
          currentStation.Datum = data.Datum
        }
      }
      editStation.synonyms.push(addSynonyms)
      editStation.name = data.StationName
      dc.splice(i, 1, editStation)
      state.grabSampleStations = dc
    },
    EditStationCategory(state, data) {
      var dc = JSON.parse(JSON.stringify(state.grabSampleStations))
      let editStation = dc.find(x => x.id == data.StationId)
      let i = dc.indexOf(editStation)
      editStation.locationType = data.StationCategory
      dc.splice(i, 1, editStation)
      state.grabSampleStations = dc
    },
    EditContinuousStationCategory(state, data) {
      var dc = JSON.parse(JSON.stringify(state.timeSeriesStations))
      let editStation = dc.find(x => x.id == data.StationId)
      let i = dc.indexOf(editStation)
      editStation.locationType = data.StationCategory
      dc.splice(i, 1, editStation)
      state.timeSeriesStations = dc
    },
    AdminAddStation(state, data) {
      var dc = JSON.parse(JSON.stringify(state.grabSampleStations))
      let newStation = {
        id: data.Id,
        medias: [],
        name: data.StationName,
        locationType: data.Type,
      }
      dc.push(newStation)
      state.grabSampleStations = dc
    },
    AdminDeleteStation(state, data) {
      var dc = JSON.parse(JSON.stringify(state.grabSampleStations))
      let deleteStation = dc.find(x => x.name == data.StationName)
      let i = dc.indexOf(deleteStation)
      dc.splice(i, 1)
      state.grabSampleStations = dc
    },
    SET_MediaTypeList: (state, data) => state.mediaTypeList = data,
    SET_StationCategories: (state, data) => state.stationCategories = data,
    SET_StationCategoriesContinuous: (state, data) => state.stationCategoriesContinuous = data,
    AddStationCategory(state, data) {
      var dc = JSON.parse(JSON.stringify(state.stationCategories))
      dc.push(data)
      state.stationCategories = dc
    },
    AddStationCategoryContinuous(state, data) {
      var dc = JSON.parse(JSON.stringify(state.stationCategoriesContinuous))
      dc.push(data)
      state.stationCategoriesContinuous = dc
    },
    UpdateStationCategory(state, data) {
      var dc = JSON.parse(JSON.stringify(state.stationCategories))
      let updateData = dc.find(x => x.Id == data.Id)
      let i = dc.indexOf(updateData)
      dc.splice(i, 1, data)
      state.stationCategories = dc
    },
    UpdateStationCategoryContinuous(state, data) {
      var dc = JSON.parse(JSON.stringify(state.stationCategoriesContinuous))
      let updateData = dc.find(x => x.Id == data.Id)
      let i = dc.indexOf(updateData)
      dc.splice(i, 1, data)
      state.stationCategoriesContinuous = dc
    },
    ChangeStationLoading: (state) => state.stationLoading = !state.stationLoading,
    SET_CalendarMark: (state, data) => state.CalendarMark = data,
    SET_TagList: (state, data) => state.tagList = data,
    UpdateTag(state, data) {
      var dc = JSON.parse(JSON.stringify(state.tagList))
      let updateTag = dc.find(x => x.Id == data.Id)
      let i = dc.indexOf(updateTag)
      dc.splice(i, 1, data)
      state.tagList = dc
    },
    AddTag(state, data) {
      var dc = JSON.parse(JSON.stringify(state.tagList))
      dc.push(data)
      state.tagList = dc
    },
    PushStationSynonyms(state, data) {
      var grab = JSON.parse(JSON.stringify(state.grabSampleStations))
      let grabStation = grab.find(x => x.name == data.name)
      grabStation.synonyms = data.synonyms
      state.grabSampleStations = grab
    },
    RollbackMediaTypeUpdate(state, data) {
      var dc = JSON.parse(JSON.stringify(state.mediaTypeList))
      var mediaTypes = dc.filter(x => data.every(y => y.MediaTypeId != x.Id))
      state.mediaTypeList = mediaTypes
    },
    SET_AvailableTimeSeries(state, data) {
      state.selectTimeSeries = data
    },
    SetCorrectionLogs(state, data) {
      data.sort((x, y) => {
        return x.DateTime < y.DateTime ? 1 : -1
      })
      state.CorrectionLogs = data
      state.Loaded = true
    },
    SetLogsError(state) {
      state.Loaded = true
      state.showLogsError = true
    },
    ClearLogs(state) {
      state.CorrectionLogs = []
      state.Loaded = false
      state.showLogsError = false
    },
    clearRecentStationIdsNavigated(state) {
      let StationListIndex = []
      let dc = JSON.parse(JSON.stringify(state.recentStationIdsNavigated))
      dc.forEach((x, index) => {
        if (state.allStationsDistinct.find(y => y.name == x)) {
          StationListIndex.push(index)
        }
      })
      if (StationListIndex) {
        let list = []
        StationListIndex.forEach(x => list.push(dc[x]))
        state.recentStationIdsNavigated = list
      } else {
        state.recentStationIdsNavigated = []
      }
      let username = authenticate.state.userinfo.username
      let stationHistory = JSON.parse(localStorageManager.getItem('stationHistory')) || []
      let userStationHistory = stationHistory.find(x => x.username == username)
      userStationHistory.stations = state.recentStationIdsNavigated
      localStorageManager.setItem('stationHistory', JSON.stringify(stationHistory))
    },
  },

  actions: {
    async getTagList({
      commit,
    }) {
      let url = 'api/Tag/list'
      try {
        axios.get(url)
          .then(res => {
            commit('SET_TagList', res.data)
            commit('ChangeStationLoading')
          })
      } catch (e) {
        console.log('Could not get tag data from \'' + url + '\'')
        throw 'Could not get tag data.'
      }
    },
    async putUpdateTag({
      commit,
    }, options) {
      axios.put('api/Tag/Update', options.data)
        .then(res => {
          commit('UpdateTag', res.data)
          options.successCb(res)
        }).catch(error => {
          options.failedCb(error)
        })
    },
    async postAddTag({
      commit,
    }, options) {
      axios.post('api/Tag/Add', options.data)
        .then(res => {
          commit('AddTag', res.data)
          options.successCb(res)
        }).catch(error => {
          options.failedCb(error)
        })
    },
    async getMediaTypeList({
      commit,
    }) {
      let url = 'api/MediaTypes/List'
      try {
        axios.get(url)
          .then(res => {
            commit('SET_MediaTypeList', res.data)
            commit('ChangeStationLoading')
          })
      } catch (e) {
        console.log('Could not get media types data from \'' + url + '\'')
        throw 'Could not get media types data.'
      }
    },

    async postAddMediaType({
      commit,
    }, options) {
      axios.post('api/MediaTypes/Add', options.data)
        .then(res => {
          commit('AddMediaType', res.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postEditStationCategory({ commit }, options) {
      axios.post('api/StationManagement/EditStationCategory', options.data)
        .then(res => {
          commit('EditStationCategory', options.data)
          commit('refreshDistinctStationsUnion')
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },

    async putUpdateMediaType({
      commit,
    }, options) {
      axios.put('api/MediaTypes/Update', options.data)
        .then(res => {
          commit('UpdateMediaType', res.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postEditContinuousStationCategory({ commit }, options) {
      axios.post('api/ContinuousStationCategory/EditContinuousCategory', options.data)
        .then(res => {
          commit('EditContinuousStationCategory', options.data)
          commit('refreshDistinctStationsUnion')
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },

    async getStationCategories({ commit }) {
      let url = 'api/StationCategory/List'
      try {
        axios.get(url)
          .then(res => {
            commit('SET_StationCategories', res.data)
            commit('ChangeStationLoading')
          })
      } catch (e) {
        console.log('Could not get station categories data from \'' + url + '\'')
        throw 'Could not get station categories data.'
      }
    },
    async getStationCategoriesContinuous({
      commit,
    }) {
      let url = 'api/ContinuousStationCategory/List'
      try {
        axios.get(url)
          .then(res => {
            commit('SET_StationCategoriesContinuous', res.data)
            commit('ChangeStationLoading')
          })
      } catch (e) {
        console.log('Could not get station categories data from \'' + url + '\'')
        throw 'Could not get station categories data.'
      }
    },

    async postAddStationCategory({
      commit,
    }, options) {
      axios.post('api/StationCategory/Add', options.data)
        .then(res => {
          commit('AddStationCategory', res.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postAddStationCategoryContinuous({
      commit,
    }, options) {
      axios.post('api/ContinuousStationCategory/Add', options.data)
        .then(res => {
          commit('AddStationCategoryContinuous', res.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },

    async putUpdateStationCategory({
      commit,
    }, options) {
      axios.put('api/StationCategory/Update', options.data)
        .then(res => {
          commit('UpdateStationCategory', res.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async putUpdateStationCategoryContinuous({
      commit,
    }, options) {
      axios.put('api/ContinuousStationCategory/Update', options.data)
        .then(res => {
          commit('UpdateStationCategoryContinuous', res.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async startDate({
      commit,
    }, data) {
      commit('startDate', data)
    },
    async endDate({
      commit,
    }, data) {
      commit('endDate', data)
    },
    async minDateBound({
      commit,
    }, data) {
      commit('minDateBound', data)
    },
    async maxDateBound({
      commit,
    }, data) {
      commit('maxDateBound', data)
    },
    async getTimeSeriesStations({
      commit,
    }, data) {
      //get program from userinfo
      var program = data.program
      try {
        var res = await axios.get('/api/LocationAPI/Get/' + program)
        var mappedData = res.data.map(m => {
          return {
            id: m.Id,
            name: m.LocationIdentifier,
            sampleType: 'continuous',
            locationType: m.LocationType,
            description: m.LocationDescription,
            medias: [],
            synonyms: [],
            position: {
              lat: m.Latitude,
              lng: m.Longitude,
            },
          }
        })
        commit('timeSeriesStations', mappedData)
        commit('refreshDistinctStationsUnion')
      } catch (e) {
        throw 'Could not get time series stations data.'
      }
    },
    async getStationDetailByName({
      dispatch,
      commit,
    }, options) {
      // options.isComplete === true will fetch/cache DataSets and related station photos, documents, notes.
      // options.isComplete === false will only fetch/cache DataSets.

      //get program from userinfo
      var program = options.program
      let url = '/api/LocationAPI/Detail?locationIds=' + stringUtils.fixedEncodeURIComponent(options.name) +
        '&roleName=' + stringUtils.fixedEncodeURIComponent(options.program)
      try {
        let res = await axios.get(url)
        let stationDetail = {
          name: options.name,
          items: {
            StationName: options.name,
            Datasets: res.data.Datasets,
          },
        }
        commit('stationDetails', stationDetail)
        if (res.data.Locations != null && res.data.Locations.length > 0) {
          commit('stationNotes', { name: options.name, items: res.data.Locations[0].Notes })
        }
      } catch (e) {
        console.log('Could not get DataSets from \'' + url + '\'')
      }
      if (options.isComplete) {
        await dispatch('getPhotoList', {
          name: options.name,
          program: program,
        })
        await dispatch('getDocumentList', {
          name: options.name,
          program: program,
        })

      }
    },
    async getWaterQualityStationDetailByName({
      commit,
    }, options) {
      let url = '/api/WaterQuality/Location/Detail/' + stringUtils.fixedEncodeURIComponent(options.name.trim())
      try {
        let res = await axios.get(url)
        let stationDetail = {
          name: options.name,
          items: {
            StationName: options.name,
            Datasets: res.data.WaterQualityDatasets,
          },
        }
        commit('waterqualityStationDetail', stationDetail)
      } catch (e) {
        console.log('Could not get dataSets from \'' + url + '\'')
        throw 'Could not get dataSets from \'' + url + '\''
      }
    },
    async getAndReturnWaterQualityStationDetailByName(_, options) {
      let url = '/api/WaterQuality/Location/Detail/' + stringUtils.fixedEncodeURIComponent(options.name.trim())
      try {
        let res = await axios.get(url)
        let stationDetail = {
          name: options.name,
          items: {
            StationName: options.name,
            Datasets: res.data.WaterQualityDatasets,
          },
        }
        options.successCb(stationDetail)
        // commit('waterqualityStationDetail', stationDetail)
      } catch (e) {
        console.log('Could not get dataSets from \'' + url + '\'')
      }
    },
    async recentStationPhotos({ commit }, {
      name: name,
      items: { StationName: stationName, Photos: photoList },
    }) {
      commit('recentStationPhotos', { name: name, items: { StationName: stationName, Photos: photoList } })

    },
    async getPhotoList({ dispatch, commit }, {
      name: stationName,
    }) {
      var stationId = ''
      if (stationName) {
        stationId = stationName
      }
      if (stationId) {
        let url = '/api/StationPhotos/Paged/' + stringUtils.fixedEncodeURIComponent(stationId)
        try {
          let res = await axios.get(url)
          let data = res.data
          let photoList = []
          let recentPhotoList = []
          var isMoreRecentPhoto = true
          let recentDate = new Date(Date.UTC(1800, 0, 1, 1, 0, 0))
          let parsedDate = new Date(Date.UTC(1800, 0, 1, 2, 0, 0))
          if (data && data.Photos && data.Photos.length) {
            let len = data.Photos.length
            let currData = {}
            let includePhoto = {}
            for (let i = 0; i < len; i += 1) {
              currData = data.Photos[i]
              parsedDate = parse(currData.UploadedAt)

              includePhoto = {
                FileName: currData.FileName,
                Thumbnail: currData.ThumbnailUrl,
                FileUrl: currData.FileUrl,
                UploadedAt: parsedDate,
              }

              photoList.push(includePhoto)

              isMoreRecentPhoto = isBefore(recentDate, parsedDate)
              if (isMoreRecentPhoto) {
                recentDate = parsedDate
                recentPhotoList = [includePhoto]
              }
            }
          }
          commit('stationPhotos', { name: stationName, items: { StationName: stationName, Photos: photoList } })
          await dispatch('recentStationPhotos', { name: stationName, items: { StationName: stationName, Photos: recentPhotoList } })
        } catch (e) {
          console.log('Could not get photo list from \'' + url + '\'')
        }
      }
    },
    async getDocumentList({ commit }, {
      name: stationName,
      program: program,
    }) {

      // name is a station name like 'WQ8'.
      // program is a program name. e.g. 'JDS' or 'Silvertip_WQ' or 'Wellgreen_WQ'.
      var stationId = ''
      if (stationName) {
        stationId = stationName
      }

      if (stationId) {
        let url = '/api/StationInfoSheet/Station/' + stringUtils.fixedEncodeURIComponent(stationId) +
          '?roleName=' + stringUtils.fixedEncodeURIComponent(program)
        try {
          let res = await axios.get(url)
          let data = res.data
          let docList = []
          if (data && 0 !== data.length) {
            let encodedUUID = ''
            let len = data.length
            let currData = {}
            for (let i = 0; i < len; i += 1) {
              currData = data[i]
              encodedUUID = stringUtils.fixedEncodeURIComponent(currData.UUID)
              docList.push({
                FileName: currData.FileName,
                Thumbnail: '/Documents/Thumbnail/' + encodedUUID,
                FileUrl: '/Documents/' + encodedUUID,
                Description: currData.Description,
                UploadedAt: parse(currData.UploadedAt), // expecting format like '2017-04-17T19:00:44Z'
              })
            }
          }
          commit('stationDocuments', {
            name: stationName,
            items: {
              StationName: stationName,
              Documents: docList,
            },
          })
        } catch (e) {
          console.log('Could not get document list from \'' + url + '\'')
        }
      }
    },

    async setUserRecentStationIdsNavigated({ commit }, options) {
      let faves = []
      let stationIds
      let indexFound
      const maxRecentLength = 5
      let username = authenticate.state.userinfo.username
      let stationHistory = JSON.parse(localStorageManager.getItem('stationHistory')) || []
      let userStationHistory = stationHistory.find(x => x.username == username)

      if (options != undefined) { //stationdetail
        let stationId = options
        faves = userStationHistory.stations
        stationIds = faves.map(stnId => stnId.toLowerCase())
        indexFound = stationIds.indexOf(stationId.toLowerCase())
        if (indexFound > -1) {
          faves.splice(indexFound, 1)
        }
        faves.unshift(stationId)
        if (faves.length > maxRecentLength) {
          faves = faves.slice(0, maxRecentLength)
        }
        userStationHistory.stations = faves
        localStorageManager.setItem('stationHistory', JSON.stringify(stationHistory))
      } else { //loadingscreen
        if (userStationHistory) {
          faves = userStationHistory.stations
          if (faves.length > maxRecentLength) {
            faves = faves.slice(0, maxRecentLength)
            userStationHistory.stations = faves
            localStorageManager.setItem('stationHistory', JSON.stringify(stationHistory))
          }
        } else {
          faves = []
          let newUserStationHistory = { username: username, stations: faves }
          stationHistory.push(newUserStationHistory)
          localStorageManager.setItem('stationHistory', JSON.stringify(stationHistory))
        }
      }
      commit('SET_USER_RECENT_STATIONS_NAVIGATED', { faves: faves })
    },

    adminAddStation({ commit }, options) {
      commit('AdminAddStation', options.data)
      commit('refreshDistinctStationsUnion')
    },
    adminDeleteStation({
      commit,
    }, options) {
      commit('AdminDeleteStation', options.data)
      commit('refreshDistinctStationsUnion')
    },
    clearRecentStationIdsNavigated({ commit }) {
      commit('clearRecentStationIdsNavigated')
    },
    async getCalendarMark({ commit }, options) {
      let url = '/api/WaterQuality/WaterQualityDataGroupingByDate?stationName=' + stringUtils.fixedEncodeURIComponent(options.stationName.trim()) + '&tenant=' + options.tenant
      try {
        const res = await axios.get(url)

        var data = {
          ...res.data,
        }
        var mediaLookUp = {
          'Ground Water': 'Water',
          'Surface Water': 'Water',
          'DRINKING WATER': 'Water',
          'WATER': 'Water',
          'Soil': 'Soil and Sediment',
          'Sediment': 'Soil and Sediment',
          'TISSUE': 'Tissue',
        }

        data.DateTimeGroups.forEach(x => {
          x.MediaTypeGroups.forEach(y => {
            if (mediaLookUp[y.MediaType]) {
              y.MediaType = mediaLookUp[y.MediaType]
            }
          })
        })

        var flagColorDic = new Map()
        flagColorDic.set('default', 'orange')
        data.IncludedFlags.forEach(x => {
          if (!x.ShowValue) {
            flagColorDic.set(x.FlagId, 'red')
          }
        })
        data.flagColorDic = flagColorDic
        commit('SET_CalendarMark', data)
      } catch (e) {
        console.log('Could not get date which have data from \'' + url + '\'')
        throw 'Could not get media types data.'
      }
    },
    async getCorrectionLogs({ commit }, Id) {
      let url = 'api/Logs/LabResults/' + Id
      await axios.get(url)
        .then(res => {
          commit('SetCorrectionLogs', res.data)
        })
        .catch(error => {
          commit('SetLogsError')
          console.error(error)
        })
    },
    clearLogs({ commit }) {
      commit('ClearLogs')
    },
    async fetchTabularData({ commit }, requestData) {
      return await axios.post('api/WaterQuality/FetchTabularData', requestData)
        .then(res => {
          return res.data.AnalytesData
        })
        .catch(error => {
          throw error
        })
    },
  },
  getters: {
    'timeSeriesStations': s => s.timeSeriesStations,
    'grabSampleStations': s => s.grabSampleStations,
    // distinctStations () returns union of time-series stations and grab-sample stations.
    'distinctStations': s => s.allStationsDistinct,
    //Can be updated to use sortProperty parameter to enable asc or desc by: 'name' or '-name'
    'grabSampleStationsSortByName': (state, getters) => {
      let sortProperty = 'name'
      let dynamicSort = (property) => {
        let sortOrder = 1
        if (property[0] === '-') {
          sortOrder = -1
          property = property.substr(1)
        }
        return (a, b) => {
          var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
          return result * sortOrder
        }
      }
      return getters.grabSampleStations.sort(dynamicSort(sortProperty))
    },
    'distinctMedias': (state, getters) => {
      var allMedias = []
      getters.grabSampleStations.forEach(function(s) {
        for (var i = 0; i < s.medias.length; i++) {
          var matchedMedia = allMedias.find(x => x.name === s.medias[i])
          if (matchedMedia) {
            matchedMedia.items.push(s)
          } else {
            allMedias.push({
              name: s.medias[i],
              items: [s],
            })
          }
        }

      })
      var el = allMedias.find(x => x.name == 'Unknown')
      allMedias.push(allMedias.splice(allMedias.indexOf(el), 1)[0])
      return allMedias
    },
    'stationDetails': (state) => state.stationDetails,
    'waterqualityStationDetail': (state) => state.waterqualityStationDetail,
    'stationDocuments': (state) => state.stationDocuments,
    'stationNotes': (state) => state.stationNotes,
    //=======

    // Always returns non-null.
    // returns array: [{
    // FileName: 'Test1',
    // Thumbnail: '/Documents/Thumbnail/be4e82ba-ff67-45b4-a4ae-2ab0e84cde86',
    // FileUrl: '/Documents/be4e82ba-ff67-45b4-a4ae-2ab0e84cde86',
    // Description: 'Test Photos2',
    // UploadedAt: date-fns.parse('2017-04-17T19:00:44Z'),
    // }]
    'filterPhotos': (state, getters) => (stationName, startDate, endDate) => {
      let matchedStn = getters.stationPhotos.find(stn => stn.name === stationName)
      if (!matchedStn) return []

      if (startDate && endDate) {
        return matchedStn.items.Photos.filter(x => startDate <= x.UploadedAt && x.UploadedAt <= endDate)
      } else {
        return matchedStn.items.Photos
      }
    },
    'photosDateTimeBoundary': state => stationName => {
      let match = state.stationPhotos.find(x => x.name == stationName)
      if (match) {
        let photo = match.items.Photos.sort(function(a, b) { return a.UploadedAt < b.UploadedAt ? -1 : 1 })
        return photo && photo.length && { minDate: photo[0].UploadedAt, maxDate: photo[photo.length - 1].UploadedAt }
      }
    },
    'recentStationPhotos': (state) => state.recentStationPhotos,
    'filterRecentPhotos': (state, getters) => stationName => { // Always returns non-null.
      // returns array: [{
      // FileName: 'Test1',
      // Thumbnail: '/Documents/Thumbnail/be4e82ba-ff67-45b4-a4ae-2ab0e84cde86',
      // FileUrl: '/Documents/be4e82ba-ff67-45b4-a4ae-2ab0e84cde86',
      // Description: 'Test Photos2',
      // UploadedAt: date-fns.parse('2017-04-17T19:00:44Z'),
      // }]

      // recentStationPhotos
      var photos = []
      var matchedStn = getters.recentStationPhotos.find(stn => stn.name === stationName)
      if (matchedStn) {
        photos = matchedStn.items.Photos
      }

      return photos
    },
    'filterNotes': (state, getters) => stationName => { // Always returns non-null.
      // returns array: [{
      // title: 'Station notes from the Aquarius', subtitle: 'Jan 20, 2014'
      // }]

      var notes = []
      var matchedStn = getters.stationNotes.find(stn => stn.name === stationName)
      if (matchedStn) {
        notes = matchedStn.items.Notes
      }

      return notes
    },
    'filterFiles': (state, getters) => stationName => { // Always returns non-null.
      // returns array: [{
      // FileName: 'MD8 Evapotranspiration Calculations_20170525.pdf',
      // Thumbnail: '/Documents/Thumbnail/58be69a2-2b3b-4e17-9e50-f794a6dbf215',
      // FileUrl: '/Documents/58be69a2-2b3b-4e17-9e50-f794a6dbf215',
      // Description: 'Station Information Sheet from Sharepoint.pdf',
      // UploadedAt: date-fns.parse('2017-08-23T21:56:45Z'),
      // }]

      var docs = []
      var matchedStn = getters.stationDocuments.find(stn => stn.name === stationName)
      if (matchedStn) {
        docs = matchedStn.items.Documents
      }
      return docs
    },
    'filterDatasets': (state) => name => state.stationDetails.find(p => p.name === name || p.name === state.currentStation),
    'filterWaterQualityDetail': (state) => name => state.waterqualityStationDetail.find(p => p.name === name),
    'wqData': state => state.wqData,
    'filteredWQData': state => {
      if (isBefore(state.endDate, state.startDate)) {
        return []
      }
      return state.wqData.filter(d => isWithinRange(d.SampleDateTime, parse(state.startDate, 'YYYY-MM-DD'), parse(addDays(state.endDate, 1), 'YYYY-MM-DD')))
    },
    'startDate': state => state.startDate,
    'endDate': state => state.endDate,
    'minDateBound': state => state.minDateBound,
    'maxDateBound': state => state.maxDateBound,
    'currentStation': state => state.currentStation,
    'currentStationId': state => {
      if (state.currentStation != null && state.currentStation != '') {
        var matched = state.grabSampleStations.find(x => x.name == state.currentStation)
        return matched == null ? null : matched.id
      }
      return null
    },
    'mediaTypeList': state => state.mediaTypeList,
    'stationCategories': state => state.stationCategories,
    'stationCategoriesContinuous': state => state.stationCategoriesContinuous,
    'tagList': state => state.tagList,
    'stationLoading': state => state.stationLoading,
    'CurrentMediaTypes': state => {
      var mediaTypes = []
      if (state.waterqualityStationDetail[0]) {
        state.waterqualityStationDetail[0].items.Datasets.forEach(element => {
          if (mediaTypes.indexOf(element.MediaType) == -1) {
            mediaTypes.push(element.MediaType)
          }
        })
      }
      return mediaTypes
    },
    'CalendarMark': state => state.CalendarMark,
    'iconList': () => {
      return [
        'help',
        'mdi-water',
        'mdi-texture',
        'mdi-weather-windy',
        'mdi-shovel',
        'mdi-water-pump',
        'gesture',
        'mdi-flower',
        'mdi-image-filter-hdr',
        'media-type-sediment-sampling',
        'media-type-incinerator',
        'media-type-field-bins',
        'media-type-underground-water-sampling',
        'media-type-battery-charging-80',
        'media-type-invert-colors',
        'media-type-partlycloudy',
        'media-type-lake-biodiversity',
        'media-type-lake-biodiversity-fish-habitat',
      ]
    },
    'MediaTypeDisplayToActualDictionary': () => {
      return {
        'Water': ['Ground Water', 'Surface Water', 'Water', 'DRINKING WATER', 'WATER', 'Process Water'],
        'Solid': ['Solid'],
        'Soil/Sediment': ['Soil', 'Sediment'],
        'Tissue': ['TISSUE'],
        'Ash': ['Ash'],
        'QAQC': ['QAQC'],
      }
    },
    'selectTimeSeries': state => state.selectTimeSeries,
    'CorrectionLogs': state => state.CorrectionLogs,
    'Loaded': state => state.Loaded,
    'showLogsError': state => state.showLogsError,
  },
}